import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import React from 'react';
import { LocalizedFilterText } from '../../../components/LocalizedFilterText';
import { useEtimTranslation } from '../../../use/etim-translation';
import { InfoCircle } from '../../../components/InfoCircle';
import { Tooltip } from '../../../components/Tooltip';

interface MultiselectOptionProps {
  item: RefinementListItem;
  attribute: string;
  refine: (value: string) => void;
  // eslint-disable-next-line react/require-default-props
  translateEtimValue?: (value: string) => string;
}

const showValueTooltip = theme.featureFlags.etimValueTooltips;

const MultiselectOption: React.FC<MultiselectOptionProps> = (props) => {
  const { item, attribute, refine } = props;
  const translateEtimValue = props.translateEtimValue ?? ((value) => value);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const valueTooltipData = showValueTooltip ? useEtimTranslation(item.value) : {};

  return (
    <div className={`ais-RefinementList-item ${item.isRefined ? 'ais-RefinementList-item--selected' : ''}`}>
      <div
        className="ais-RefinementList-label"
        onClick={() => {
          refine(item.value);
        }}
      >
        <input
          className="ais-RefinementList-checkbox"
          type="checkbox"
          name={item.label}
          id={item.value}
          checked={item.isRefined}
        />
        <span className="ais-RefinementList-labelText">
          <LocalizedFilterText attribute={attribute} value={item.label} translateEtimValue={translateEtimValue} />
          {valueTooltipData?.tooltip && (
            <Tooltip tooltipAnchor={<InfoCircle />} tooltipContent={valueTooltipData?.tooltip} />
          )}
        </span>
        <span className="ais-RefinementList-count">{item.count}</span>
      </div>
    </div>
  );
};

export default MultiselectOption;
